import * as React from 'react';

const Globe24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 16.5h5.25a.75.75 0 0 0 0-1.5h-5.026c.116-.983.178-1.923.178-3a25 25 0 0 0-.178-3h5.026a.75.75 0 0 0 0-1.5H16C15.303 3.722 13.775 1 12.002 1S8.7 3.722 8.004 7.5H3A.75.75 0 0 0 3 9h4.779a25 25 0 0 0-.177 3c0 1.077.061 2.017.177 3H3a.75.75 0 0 0 0 1.5h5.004c.696 3.778 2.225 6.5 3.998 6.5s3.3-2.722 3.997-6.5Zm-1.528 0c-.197.99-.453 1.975-.752 2.721-.356.89-.743 1.511-1.096 1.884-.35.37-.56.395-.622.395-.063 0-.274-.025-.623-.395-.353-.373-.74-.993-1.096-1.884-.299-.746-.555-1.731-.752-2.721zM9.29 15c-.122-.97-.188-1.91-.188-3s.066-2.03.188-3h5.424c.12.97.188 1.91.188 3s-.067 2.03-.189 3zm.24-7.5c.198-.99.454-1.975.753-2.721.356-.89.743-1.511 1.096-1.884.35-.37.56-.395.623-.395s.273.025.622.395c.353.373.74.993 1.096 1.884.299.746.555 1.73.752 2.721H9.531Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.5a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19m0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
  }
));
Globe24.Size = 24;
Globe24.Title = "Globe";

export { Globe24 as default };
